
import { Sparkles, Users, Building, BarChart } from "lucide-react";

export const ComingSoonSection = () => {
  const features = [
    {
      icon: Sparkles,
      title: "Smart Marketing & Promotions",
      description: "AI-powered event marketing & VIP deals"
    },
    {
      icon: Users,
      title: "AI-Driven Staffing Solutions",
      description: "Fill shifts instantly with available bartenders"
    },
    {
      icon: Building,
      title: "Responsible Service Compliance",
      description: "RSA & RSG training & automated tracking"
    },
    {
      icon: BarChart,
      title: "Real-Time Inventory & Analytics",
      description: "Optimize bar stock & boost sales"
    }
  ];

  return (
    <div className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16">
          Coming Soon
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-gray-900/50 backdrop-blur-sm border border-gray-800 hover:border-gray-700 transition-all duration-300"
            >
              <div className="flex items-center gap-4 mb-4">
                <feature.icon className="w-12 h-12 text-purple-400" />
                <span className="px-3 py-1 text-xs font-semibold bg-purple-500/20 text-purple-300 rounded-full border border-purple-500/30">
                  Coming Soon
                </span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
              <p className="text-gray-400 mb-4">{feature.description}</p>
              <div className="w-full bg-gray-800 rounded-full h-2">
                <div className="bg-gradient-to-r from-purple-600 to-blue-600 h-2 rounded-full animate-pulse" style={{ width: '60%' }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
